import { Record } from 'immutable';

const CreditLineFacilityAccountInfoRecord = Record({
  name: '',
  accountId: '',
  accountNumber: '',
  bankNumber: '',
});

export default class CreditLineFacilityAccountInfo extends CreditLineFacilityAccountInfoRecord {
  static deserialize(jsonObject = {}) {
    return new CreditLineFacilityAccountInfo(jsonObject);
  }
}
